import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'

import { get, find } from 'lodash'
import Icon from '@scoir/components-core/dist/components/Icon'
import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'

import { isShortDuration } from '../durationHelper'
import VisitOpening from '.'
import requiredPropTypes from './requiredPropTypes'

import slotIcon from 'icons/filter-none.svg'

import './WeekView.scss'

export const WeekView = (props) => {
  const { event, scid, userId } = props
  const isMultiEvent = get(event, 'Type') === 'multi'
  const participant = find(get(event, 'Participants', []), { Scid: scid })
  const myRep = find(get(participant, 'Representatives', []), { UserId: userId })
  const isPending = get(myRep, 'SystemState') === 'pending_state'
  const virtual = get(event, 'Virtual', false)
  return (
    <VisitOpening
      {...props}
      className={cn('week', {
        'short-duration': isShortDuration(event),
        'pending-event-summary': isPending,
      })}
      summary={
        <React.Fragment>
          {isPending ? (
            <strong>Pending Request</strong>
          ) : (
            <strong className={cn({ virtual: virtual })}>
              {virtual && 'Virtual '}
              <span>
                <span>{isMultiEvent && 'Multi-'}Visit </span>
                <span className={cn({ 'virtual-nowrap': virtual })}>
                  Availability {virtual && <VirtualVisitInverted />}
                </span>
              </span>
            </strong>
          )}
          <br />
          <div className="high-school-name">
            {isMultiEvent && (
              <Icon
                className="slot-icon"
                def={slotIcon}
                size="xs"
                beforeText
              />
            )}
            <span>{event.HighSchoolName}</span>
          </div>
        </React.Fragment>
      }
    />
  )
}
WeekView.propTypes = {
  ...requiredPropTypes,
  userId: PropTypes.string.isRequired,
  scid: PropTypes.number.isRequired,
}

export default connect((store) => ({
  userId: store.user.record.Id,
  scid: store.user.record.Scid,
}))(WeekView)
